import { service } from "@/api/service ";
import { toastError, toast } from "@/components/custom/Toast";
import store from "../..";
// import router from "@/router";

const state = {
  jobHistories: [],
  jobHistoryByEmployeeId: [],
  jobHistoryById: {},
  jobHistory: {},
  currentJob: {},
  department: {},
  addStatus: false,
  deleteStatus: false,
  editStatus: false,
  finishStatus: false,
  changeDepartmentStatus: false,
  pagination: {},
};

const getters = {
  jobHistoriesListGet: (state) => state.jobHistories,
  jobHistoryByEmployeeIdListGet: (state) => state.jobHistoryByEmployeeId,
  jobHistoryByIdGet: (state) => state.jobHistoryById,
  currentJobGet: (state) => state.currentJob,
  paginationGet: (state) => state.pagination,
};

const actions = {
  getJobHistories({ commit }, payload) {
    console.log(payload, "history payload ");
    let page = payload.isModal ? 0 : store.state.page.page;
    service
      .getFun(`job-histories?employee_id=${payload.EMPLOYEE}&page=${page}`)
      .then(
        (obj) => {
          let result = obj?.data?.data;
          const pageresult = {
            currentPage: obj?.data.current_page,
            lastPage: obj?.data.last_page,
            total: obj?.data.total,
            itemsPerPage: 50,
          };
          commit("jobHistoriesListSet", result);
          commit("setPagination", pageresult);
        },
        (error) => {
          console.log("jobHistories..." + error);
          toastError(error);
        }
      );
  },
  getJobHistoryByEmployeeId({ commit }, payload) {
    service.getFun(`job-history/${payload}`).then(
      (obj) => {
        let result = obj.data.job_history;
        commit("jobHistoryByEmployeeId", result);
      },
      (error) => {
        toastError(error);
      }
    );
  },
  getJobHistoryById({ commit }, payload) {
    service.getFun(`job-history/${payload}`).then(
      (obj) => {
        let result = obj.data;
        commit("jobHistoryById", result);
      },
      (error) => {
        toastError(error);
      }
    );
  },
  getCurrentJob({ commit }, payload) {
    service.getFun(payload, `current-job/`).then((obj) => {
      let result = obj.data.current_job;
      commit("currentJob", result);
    });
  },
  assignJob({ commit }, payload) {
    service
      .postFun(service.deleteNullValues(payload), `job-history/store`, null, {
        action: "getJobHistories",
      })
      .then((result) => {
        if (result) {
          commit("addJobHistoryStatus", result.success);
          toast("All Good");
        } else {
          commit("addJobHistoryStatus", false);
        }
      });
  },
  finishJob({ commit }, payload) {
    service
      .postFun(service.deleteNullValues(payload), `job-history/finish`, null, {
        action: "getJobHistories",
      })
      .then((result) => {
        if (result) {
          commit("finishJobStatus", result.success);
          toast("All Good");
        } else {
          commit("finishJobStatus", false);
        }
      });
  },
  changeDepartment({ commit }, payload) {
    service
      .postFun(service.deleteNullValues(payload), "job-history/edit", null, {
        action: "getJobHistories",
        page: store.state.page.page,
      })
      .then((result) => {
        if (result) {
          commit("departmentStatus", result.success);
          toast("All Good");
        } else {
          commit("departmentStatus", false);
        }
      });
  },
};

const mutations = {
  jobHistoriesListSet(state, jobHistories) {
    state.jobHistories = jobHistories;
  },
  jobHistoryByEmployeeId(state, jobHistoryByEmployeeId) {
    state.jobHistoryByEmployeeId = jobHistoryByEmployeeId;
  },
  jobHistoryById(state, jobHistoryById) {
    state.jobHistoryById = jobHistoryById;
  },
  currentJob(state, currentJob) {
    state.currentJob = currentJob;
  },
  addJobHistoryStatus(state, success) {
    state.addStatus = success;
  },
  finishJobStatus(state, success) {
    state.finishStatus = success;
  },
  departmentStatus(state, success) {
    state.changeDepartmentStatus = success;
  },
  setPagination(state, pageResult) {
    state.pagination = pageResult;
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
